module.exports = __webpack_public_path__ + "img/install.ac3ad002.webp";